import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {CircularProgress} from '@mui/material';
import Box from '@mui/material/Box';
import Alert, {useAlert} from 'components/snacks/Alert';
import {axiosInstance} from 'api/Api';
import Sidebar from './Sidebar';

const Login = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');

    const alert_timeout = 10000
    const alertStore = useAlert(alert_timeout);

    // LOAD
    useEffect(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('login_phone_number');
        localStorage.removeItem('user_info');
    }, []);

    const submitForm = (e) => {
        e.preventDefault();
        if (phoneNumber === '') {
            alertStore.AddAlert({
                key: 'empty',
                message: 'لطفا شماره همراه یا ایمیل را وارد کنید',
                severity: 'error',
                auto_hide: true
            });
        } else {
            setLoading(true);
            axiosInstance()
                .get(`/check-mobile?mobile=${phoneNumber}`)
                .then((res) => {
                    const result = res.data;
                    if (result.status === 200) {
                        localStorage.setItem('login_phone_number', phoneNumber);
                        const urlParams = new URLSearchParams(window.location.search);
                        const product = urlParams.get('product');
                        const locale = urlParams.get('locale');
                        if (result.login) {
                            return history.push(`/login-password${product ? `?product=${product}&locale=${locale}` : ''}`);
                        } else if (result.register) {
                            return history.push(`/register${product ? `?product=${product}&locale=${locale}` : ''}`);
                        } else {
                            return alertStore.AddAlert({
                                key: '300',
                                message: 'مشکلی پیش آمده است. لطفا دوباره امتحان کنید.',
                                severity: 'error',
                                auto_hide: true
                            });
                        }
                    } else {
                        alertStore.AddAlert({
                            key: '400',
                            message: result.msg,
                            severity: 'error',
                            auto_hide: true
                        });
                    }
                })
                .catch((err) => {
                    if (err?.response?.data?.message)
                        alertStore.AddAlert({
                            key: '500',
                            message: err?.response?.data?.message,
                            severity: 'error',
                            auto_hide: true
                        });
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    // JSX
    return (
        <div className={'row mx-0 px-0 '}>
            {/* **************** TITLE **************** */}
            <div className="col-12 col-md-6 px-0">
                <Sidebar/>
            </div>
            {/* **************** FORM **************** */}
            <div className="col-12 col-md-6 px-0">
                {loading ? (
                    <div className="h-full h-md-fit d-flex justify-content-center align-items-center mt-5 my-md-0">
                        <Box sx={{display: 'flex', marginRight: '20px'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                ) : (
                    <form
                        method="post"
                        onSubmit={submitForm}
                        className="h-full h-md-fit d-flex justify-content-center align-items-center mt-5 my-md-0"
                    >
                        <div style={{width: '65%'}}>
                            <h1 className="mb-10 mt-10 mt-md-0 text-center">
                                ورود / ثبت نام
                            </h1>
                            <hr/>
                            <label
                                htmlFor="login_phone_number"
                                className="form-label fs-5 mt-10"
                            >
                                شماره همراه یا ایمیل خود را وارد کنید:
                            </label>
                            <input
                                type="text"
                                id="login_phone_number"
                                className="form-control login-input direction-ltr"
                                placeholder=""
                                autoFocus={true}
                                onChange={(e) => {
                                    setPhoneNumber(e.target.value);
                                }}
                                value={phoneNumber}
                            />
                            <button className="btn btn-primary mt-3">تایید</button>
                        </div>
                    </form>
                )}
            </div>
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </div>
    );
};

export default Login;
